import { createSelector } from 'reselect';

const selectLogoutPage = state => state.logoutPage;

export const selectVisible = createSelector(
    [selectLogoutPage],
    logoutPage => logoutPage.visible
);
